import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=abb3b0f0&scoped=true"
import script from "./icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./icon.scss?vue&type=style&index=0&id=abb3b0f0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_css-loader@4.3.0_webpack@4.46.0__ejs@3.1.10_0212d38a6ce0de8ef75b0a1c6dc51def/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb3b0f0",
  null
  
)

export default component.exports